/**
 * Bureau data extraction utilities.
 */

import { BureauDetail } from '../../../../services/CreditAnalysisService';

/** Find a bureau by name (case-insensitive partial match). */
export const findBureau = (bureaus: BureauDetail[], name: string) =>
    bureaus.find(b => (b.bureau_name || b.bureau || '').toUpperCase().includes(name.toUpperCase()));

/** Extract PF registration data from bureau details (AgroScore or Serasa). */
export const extractPfRegistration = (bureaus: BureauDetail[]) => {
    const agri = findBureau(bureaus, 'ACRISCORE');
    const serasa = findBureau(bureaus, 'SERASA');
    const source = agri || serasa;
    if (!source) return null;

    const sourceData: Record<string, any> = (source.data as Record<string, any>) || {};
    const registration = sourceData.registration || sourceData.reports?.[0]?.registration;
    const optScore = sourceData.optionalFeatures?.score || sourceData.reports?.[0]?.score;

    const score = optScore
        ? { score: optScore.score, defaultRate: optScore.defaultRate, scoreClass: optScore.scoreClass || optScore.range }
        : sourceData.score !== undefined
            ? { score: sourceData.score, defaultRate: sourceData.defaultRate, scoreClass: sourceData.range }
            : null;

    const bureauName = agri ? 'AgroScore' : 'Serasa';

    if (registration) {
        return { ...registration, _bureau: bureauName, _score: score };
    }
    return { _bureau: bureauName, _raw: sourceData };
};
